import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

// Masked line-by-line reveal for headings
export const LineReveal = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={i} className="mask-reveal">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, ease, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Scroll-triggered fade up
export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

export const fadeStagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};
export const fadeItem = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease } },
};
